import React from 'react';

export const Step2Aside = ({ handleBackClick }) => (
  <>
    <div className="px-8 pt-14 pb-28 bg-[#101733] relative">
      <div className="flex items-center space-x-2 mb-10">
        <a href="/professionals" className="text-[#007DD1]">
          <img src="/img/pure-reg.svg" alt="Logo" />
        </a>
      </div>

      <p className="text-[#007DD1] text-base font-semibold pb-3">Register</p>

      <h2 className="text-[#F3F4F8] text-2xl font-semibold pb-3">
          Register to gain access to our range of lifetime mortgages
      </h2>

      <p className="text-[#E1E4F5] text-base font-450 pb-8">
        <span className="font-bold">Step 2:</span> We need a few details about your company to get your new account set up.
      </p>

      <button
        type="button"
        onClick={handleBackClick}
        className="appearance-none bg-transparent border-0 p-0 m-0 text-left cursor-pointer flex items-center gap-2 pb-10 bg-[url(/img/icons/line-16.svg)] bg-no-repeat bg-[1.5rem]"
      >
        <span className="relative p-6 bg-[#101733] border border-[#B6BED9] rounded-[50%]">
          <span className="absolute inset-[1rem] text-[#F3F4F8] text-sm text-center">
            <img src="/img/icons/check.svg" alt="Check" className="w-4 h-4" />
          </span>
        </span>
        <p className="text-[#B6BED9] text-base">Initial details</p>
      </button>

      <div className="flex items-center gap-2 pb-10 bg-[url(/img/icons/line-16.svg)] bg-no-repeat bg-[1.5rem]">
        <span className="relative p-6 bg-[#212C55] border border-[#F3F4F8] rounded-[50%]">
          <span className="absolute inset-[1rem] text-[#F3F4F8] text-sm text-center">2</span>
        </span>
        <p className="text-[#F3F4F8] text-base font-semibold">Company details</p>
      </div>

      <div className="flex items-center gap-2 pb-10">
        <span className="relative p-6 bg-[#101733] border border-[#465177] rounded-[50%]">
          <span className="absolute inset-[1rem] text-[#717999] text-sm text-center">3</span>
        </span>
        <p className="text-[#717999] text-base">Personal information</p>
      </div>
    </div>

    <div
      className="relative bg-[#101733] w-full h-32 flex flex-col justify-center items-center"
      style={{
        clipPath: 'ellipse(60% 40% at 50% 10%)',
      }}
    >
    </div>
  </>
);
